"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyScoresApi = void 0;
const handlers_1 = require("../handlers");
exports.propertyScoresApi = (http, prefix = '/property-score') => ({
    getAllForOwner(ownerId) {
        return http.get(`${prefix}/customer/${ownerId}`).catch(handlers_1._404([]));
    },
    getPropertyScoreByProperty(propertyId) {
        return http.get(`${prefix}/property/${propertyId}`).catch(handlers_1._404([]));
    },
    snoozeAttributeByProperty(propertyId, attributeName) {
        return http.put(`${prefix}/property/${propertyId}/attribute/${attributeName}/snooze`).catch(handlers_1._404([]));
    },
    markAttributesAsViewedByProperty(propertyId) {
        return http.put(`${prefix}/property/${propertyId}/attributes/viewed`).catch(handlers_1._404([]));
    }
});
//# sourceMappingURL=index.js.map